


<div>
  <router-outlet></router-outlet>
  <router-outlet name="modal"></router-outlet>
  <app-julia-chat *ngIf="showJuliaChat"></app-julia-chat>
</div>